module.exports = __webpack_public_path__ + "img/jxk_zgdw.47aa63fb.svg";